import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const HomepageVisionMission = () => {
    const { t } = useTranslation();

    return (
        <div className='homepage-vision-mission-content'>
            <div className="container">
                <div className="row justify-content-between">
                    <div className="col-lg-5">
                        <h5 className='mb-4'>{t('Paragon Yatırım ile Forex Dünyasını Keşfedin')}</h5>
                        <p>{t('Paragon Yatırım, forex piyasasında uzmanlaşmış güçlü stratejiler ve son teknolojiye sahip güvenli işlem platformlarıyla yatırımcılara en verimli ticaret deneyimini sunuyor.')}</p>
                        <p className='mb-0'>{t('Global piyasalarda hızla değişen koşullara uyum sağlayarak, yatırımcılarına geniş bir döviz çifti yelpazesi, düşük spread oranları ve yüksek likidite imkânı tanıyor. Paragon Yatırım, profesyonel analizler ve güçlü ticaret araçlarıyla, yatırımcılarının bilinçli kararlar alarak kazançlarını maksimize etmelerine yardımcı oluyor.')}</p>
                        {/* <div className='mt-lg-5 mt-4'>
                            <div className='d-flex align-items-center mb-3'>
                                <i className="fa-solid fa-check text-success"></i>
                                <span className='ms-3'> Lorem ipsum dolor sit amet consectetuer adipiscing elit.</span>
                            </div>
                            <div className='d-flex align-items-center mb-3'>
                                <i className="fa-solid fa-check text-success"></i>
                                <span className='ms-3'> Lorem ipsum dolor sit amet consectetuer adipiscing elit.</span>
                            </div>
                            <div className='d-flex align-items-center'>
                                <i className="fa-solid fa-check text-success"></i>
                                <span className='ms-3'> Lorem ipsum dolor sit amet consectetuer adipiscing elit.</span>
                            </div>
                        </div> */}
                        <div>
                            <Link to="/about-us">
                                <button className='btn-primary-v2 mt-5'>{t('Hakkımızda')}</button>
                            </Link>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className='d-flex justify-content-end'>
                            <div className='me-lg-4 pt-lg-4 pt-5 mobile-w-100'>
                                <div className='homepage-vision-mission-content__square mb-3'>
                                    <div className="icon">
                                        <img width="24" height="24" src="https://img.icons8.com/ios-glyphs/30/fast-forward.png" alt="fast-forward" />
                                    </div>
                                    <span className='ms-3'>{t('Hızlı İşlem')}</span>
                                </div>
                                <div className='homepage-vision-mission-content__square mb-3'>
                                    <div className="icon">
                                        <img width="26" height="26" src="https://img.icons8.com/ios-filled/50/low-priority.png" alt="low-priority" />
                                    </div>
                                    <span className='ms-3'>{t('Düşük Spread')}</span>
                                </div>
                                <div className='homepage-vision-mission-content__square'>
                                    <div className="icon">
                                        <img width="28" height="28" src="https://img.icons8.com/fluency-systems-filled/50/education.png" alt="education" />
                                    </div>
                                    <span className='ms-3'>{t('Eğitim Desteği')}</span>
                                </div>
                            </div>
                            <div className='position-relative vision-mission-image'>
                                <img src="https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/germany-bavaria-munich-Y6EZQZN.png" alt="" width="250px" />
                                <div className="homepage-vision-mission-overlay"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomepageVisionMission